export default {"src":"/_next/static/media/affiliate-no.f5375098.svg","height":24,"width":34};